import React, { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import { ButtonSquare, CancelButton } from '@/modules/base/components/buttons'
import { SignatureWizardSteps, reset, setActiveSigner, setActiveStep } from '@/redux/ducks/signature/edit'
import { useSignatureContext } from '@/modules/signature/_helpers/SignatureContext'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  button: {
    width: 'unset',
  },
}), { name: 'SignatureFormActions' })

interface SignatureFormActionsProps {
  onAbort?: () => void,
}

const SignatureFormActions = ({ onAbort }: SignatureFormActionsProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { activeStep, signers, dueDate } = useSelector(state => state.signature.edit)
  const { setPlacingMode } = useSignatureContext()

  const formValid = useMemo(() => {
    if (activeStep === SignatureWizardSteps.form) {
      const invalidSigner = signers.filter((signer) => !signer.id && !signer.email)
      return !invalidSigner.length && dueDate
    }
  }, [activeStep, signers, dueDate])

  const handleContinue = (): void => {
    setPlacingMode(true)
    dispatch(setActiveSigner({ signer: signers[0] }))
    dispatch(setActiveStep({ step: SignatureWizardSteps.signaturePlacement }))
  }
  const handleAbort = (): void => {
    onAbort?.()
    dispatch(reset())
  }

  return (
    <div className={classes.root}>
      <div>
        <CancelButton
          label={lang.generics.abort}
          onClick={handleAbort} />
      </div>
      <div>
        <ButtonSquare
          type="submit"
          label={lang.signature.form.button.placeSignature}
          disabled={!formValid}
          customClass={classes.button}
          onClick={handleContinue} />
      </div>
    </div>
  )
}

export default SignatureFormActions
